import { render, staticRenderFns } from "./CriaQRCode.vue?vue&type=template&id=c2b74f58"
import script from "./CriaQRCode.vue?vue&type=script&lang=js"
export * from "./CriaQRCode.vue?vue&type=script&lang=js"
import style0 from "./CriaQRCode.vue?vue&type=style&index=0&id=c2b74f58&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports